import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import minimap from "../../Assets/minimap.png";
// import NaverMap from "./NaverMap";
import StaticNaverMap from "./StaticNaverMap";

function Support() {
  //   var map = new naver.maps.Map('map', {
  //     center: new naver.maps.LatLng(37.3595704, 127.105399),
  //     zoom: 15
  // });
  const fetchMapImage = async () => {
    const response = await fetch(
      "https://maps.apigw.ntruss.com/map-static/v2/raster?w=300&h=300&center=127.1054221,37.3591614&level=16",
      {
        headers: {
          "X-NCP-APIGW-API-KEY-ID": "7w4gk910ed",
          "X-NCP-APIGW-API-KEY": "your-client-secret",
        },
      }
    );
    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);
    return imageUrl;
  };
  return (
    <Container fluid className="support-section">
      <Container>
        <div className="support-header">
          <h1 className="support-heading">고객 지원</h1>
          <p className="support-description">
            고객의 목소리에 귀를 기울이고,
            <br className="mobile-line-break" /> 고객의 요구에 따라 최선을
            다하는 것이
            <br className="mobile-line-break" /> 동진에어택의 목표입니다.
          </p>
          <p className="support-description">
            문의사항이 있으시면 <br className="mobile-line-break" />
            언제든지 연락 주시기 바랍니다.
          </p>
        </div>

        <div className="support-content">
          <div className="contact-section">
            <h2 className="contact-title">연락처</h2>

            <div className="contact-info">
              <p>
                <strong>OFFICE :</strong> 031-790-1900{" "}
                <br className="mobile-line-break" />/ 031-790-1901
              </p>
              <p>
                <strong>TEL :</strong> 010-3038-9709
              </p>
              <p>
                <strong>Email :</strong> dongjinat@nate.com
              </p>
            </div>
          </div>

          <div className="location-section">
            <h2 className="location-title">오시는 길</h2>
            <div className="location-info">
              <p>
                <strong>영업 본부</strong> <br />

                경기도 하남시 조정대로 150 <br />
                ITECO 하남지식산업센터 731호
              </p>
            </div>
          </div>

          <div className="map-section">
            <div className="map-container">
              <img
                src={minimap}
                alt="오시는 길 약도"
                className="minimap-image"
              />
            </div>

            {/* <div className="naver-map-container">
              <img src="https://maps.apigw.ntruss.com/map-static/v2/raster-cors?w=300&h=300&center=127.1054221,37.3591614&level=16&X-NCP-APIGW-API-KEY-ID=7w4gk910ed" />
              <img src="https://maps.apigw.ntruss.com/map-static/v2/raster-cors?w=300&h=300&center=127.1054221,37.3591614&level=16&X-NCP-APIGW-API-KEY-ID=qukkxbyqtl" />

              <StaticNaverMap
                clientId="7w4gk910ed"
                clientSecret=""
                lat={37.5454}
                lng={127.2245}
                zoom={17}
                height={500}
              />
            </div> */}
          </div>
        </div>
      </Container>
    </Container>
  );
}

// return (
//   <iframe
//     src="https://map.naver.com/p/entry/place/1279279224"
//     width="100%"
//     height="500"
//     style={{ border: 0, borderRadius: "10px" }}
//     allowFullScreen=""
//     loading="lazy"
//     title="네이버 지도"
//   ></iframe>
// );
export default Support;
